import { TravelApiInterface as ProTravelApiInterface } from "@syadem/kairos-pro-js";
import { TravelApiInterface as TeamTravelApiInterface } from "@syadem/kairos-team-js";
import { ActionResult } from "../../actionResult";
import { AppStore } from "../../store";
import { Service } from "../service";

interface Payload {
  organizationId: string | null;
  teamId: string | null;
  healthRecordId: string;
  travelId: string;
}

export class DeleteTravelService implements Service<Payload, void> {
  constructor(
    private readonly proTravelApi: ProTravelApiInterface,
    private readonly teamTravelApi: TeamTravelApiInterface,
    private readonly store: AppStore,
  ) {}

  async call({ organizationId, teamId, healthRecordId, travelId }: Payload): Promise<ActionResult<void>> {
    if (organizationId && teamId) {
      await this.teamTravelApi.deleteTravel(organizationId, teamId, healthRecordId, travelId);
    } else {
      await this.proTravelApi.deleteTravel(healthRecordId, travelId);
    }

    this.store.setState((state) =>
      state.healthRecords?.[healthRecordId]
        ? {
            healthRecords: {
              ...state.healthRecords,
              [healthRecordId]: {
                ...state.healthRecords[healthRecordId],
                travels: (state.healthRecords[healthRecordId].travels ?? []).filter(({ id }) => id !== travelId),
              },
            },
          }
        : state,
    );

    return { type: "success", value: undefined };
  }
}
